export default __webpack_public_path__ + "static/media/user-avatar.7f15321c.svg";